/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { ModalContext } from "../../context/modal";
import { authApi } from "../../services/api";
import { TOASTIFY_OPTIONS } from "../../style/global";
import { DefaultButton, MyModalBody, MyModalInput } from "../../style/default";

function ModalLandbotEdit({ open, data, populateTable, clients }) {
  const { handleOpenModal } = useContext(ModalContext);
  const [channelToken, setChannelToken] = useState("");

  //populate data
  useEffect(() => {
    if (data) {
      setChannelToken(data?.channelToken);
    }
  }, [data]);

  const handleLandbotEdit = async () => {
    if (!channelToken) {
      toast.error("Insira o token!", TOASTIFY_OPTIONS);
      return;
    }

    try {
      if (!data._id) {
        toast.error("Houve um erro interno.", TOASTIFY_OPTIONS);
        return;
      }
      const reqData = await authApi.post("/landbotchannel/edit", {
        _id: data._id,
        channelToken: channelToken,
      });
      if (reqData.status === 200) {
        populateTable();
        handleOpenModal();
        toast.success("Canal landbot editado com sucesso.", TOASTIFY_OPTIONS);
      }
    } catch (error) {
      toast.error("Houve um erro interno.", TOASTIFY_OPTIONS);
      handleOpenModal();
    }
  };

  return (
    <Modal show={open} onHide={handleOpenModal} size="lg" backdrop="static">
      <Modal.Header closeLabel="" closeButton>
        <Modal.Title>
          Edição do canal: {data?.channelToken}{" "}
          {data?.accountName.length ? `(${data?.accountName})` : ""}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <MyModalBody>
          <label>Token</label>
          <MyModalInput
            type="name"
            placeholder={"ex: ti"}
            onChange={(e) => setChannelToken(e.target.value)}
            value={channelToken}
          />
        </MyModalBody>
      </Modal.Body>
      <Modal.Footer>
        <DefaultButton onClick={handleLandbotEdit}>Editar</DefaultButton>
      </Modal.Footer>
    </Modal>
  );
}

export { ModalLandbotEdit };
